export enum VoucherType{
    VISTA="Vista",
    SOLE="Sole",
    OTHERS="Altro"
}